import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import ChiSiamo from "@/pages/ChiSiamo";
import StatutoBilancio from "@/pages/StatutoBilancio";
import Social from "@/pages/Social";
import Corsi from "@/pages/Corsi";
import Medagliere from "@/pages/Medagliere";
import Lotta from "@/pages/Lotta";
import Pesistica from "@/pages/Pesistica";
import BJJ from "@/pages/BJJ";
import Grappling from "@/pages/Grappling";
import DifesaPersonale from "@/pages/DifesaPersonale";
import GinnasticaPosturale from "@/pages/GinnasticaPosturale";
import DoveSiamo from "@/pages/DoveSiamo";
import CookiePolicy from "@/pages/CookiePolicy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/chi-siamo" element={<ChiSiamo />} />
              <Route path="/statuto-bilancio" element={<StatutoBilancio />} />
              <Route path="/social" element={<Social />} />
              <Route path="/corsi" element={<Corsi />} />
              <Route path="/medagliere" element={<Medagliere />} />
              <Route path="/lotta" element={<Lotta />} />
              <Route path="/pesistica" element={<Pesistica />} />
              <Route path="/bjj" element={<BJJ />} />
              <Route path="/grappling" element={<Grappling />} />
              <Route path="/difesa-personale" element={<DifesaPersonale />} />
              <Route path="/ginnastica-posturale" element={<GinnasticaPosturale />} />
              <Route path="/dove-siamo" element={<DoveSiamo />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
            </Route>
          </Routes>
          <CookieBanner />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
